module.exports = __webpack_public_path__ + "04_short_black.25b036de.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/04_short_black.png
// module id = iX74
// module chunks = 0